function getClickedColor(event) {
  const input = event.target.closest('input[type="radio"]');

  if (input && input.value) {
    return input.value.trim();
  }

  const label = event.target.closest('label');

  if (label) {
    const forId = label.getAttribute('for');
    const linkedInput = forId ? document.getElementById(forId) : null;

    if (linkedInput && linkedInput.value) {
      return linkedInput.value.trim();
    }

    return label.textContent.trim();
  }

  return null;
}

function updateComplementaryProducts(forcedColor) {
  const selectedColor = forcedColor;
  if (!selectedColor) return;

  const items = document.querySelectorAll('.mm-variant-match-card');
  if (!items.length) return;

  items.forEach((item) => {
    const variantsJson = item.getAttribute('data-variants');
    if (!variantsJson) return;

    let variants = [];

    try {
      variants = JSON.parse(variantsJson);
    } catch (e) {
      return;
    }

    const matched =
      variants.find(
        (v) =>
          v.option1 === selectedColor ||
          v.option2 === selectedColor ||
          v.option3 === selectedColor
      ) || variants[0];

    if (!matched) return;

    item.querySelectorAll('a').forEach((link) => {
      const baseUrl = link.href.split('?')[0];
      link.href = baseUrl + '?variant=' + matched.id;
    });

    const img = item.querySelector('img');

    if (img && matched.featured_image) {
      const newSrc = matched.featured_image.src;

      img.style.transition = 'opacity 0.25s ease';
      img.style.opacity = '0';

      setTimeout(() => {
        img.src = newSrc;
        img.removeAttribute('srcset');

        if (img.dataset && img.dataset.src) {
          img.dataset.src = newSrc;
        }

        img.style.opacity = '1';
      }, 150);
    }

    const input = item.querySelector('input[name="id"]');
    if (input) {
      input.value = matched.id;
    }

    const quickView = item.querySelector('quick-view');
    if (quickView) {
      const baseQuickViewUrl = quickView.getAttribute('data-product-url').split('?')[0];

      quickView.setAttribute(
        'data-product-url',
        baseQuickViewUrl + '?variant=' + matched.id
      );
    }
  });
}

document.addEventListener('click', function (event) {
  const clickedColor = getClickedColor(event);
  if (!clickedColor) return;

  setTimeout(() => {
    updateComplementaryProducts(clickedColor);
  }, 150);
});







